import React, { useEffect, useState, useRef } from 'react';
import Button from '@mui/material/Button';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import MusicOffIcon from '@mui/icons-material/MusicOff';
import IconButton from '@mui/material/IconButton';
import StopIcon from '@mui/icons-material/Stop';
import { ReactComponent as Forward5Icon } from './../../assets/forward5.svg';
import DialogPreviewPlayer from './DialogPreviewPlayer';
import Stack from '@mui/material/Stack';
import previewPlayerStore from '../../stores/previewPlayer';
import SvgIcon from '@mui/material/SvgIcon';
import sessionStore from '../../stores/session';
import TR from '../../Trans';
import accountStore from '../../stores/account';
import playerStore from '../../stores/player';
import musicPlayerStore from '../../stores/musicPlayer';

function DialogPlayer(props) {

  const sessionToken = sessionStore((state) => state.sessionToken);
  const isPlaying = previewPlayerStore((state) => state.isPlaying);
  const getStreamUrl = previewPlayerStore((state) => state.getStreamUrl);
  const currentTime = previewPlayerStore((state) => state.currentTime);
  const setFrom = previewPlayerStore((state) => state.setFrom);
  const setIsPlaying = previewPlayerStore((state) => state.setIsPlaying);
  const streamUrl = previewPlayerStore((state) => state.streamUrl);
  const account = accountStore((state) => state.account);
  const isPlayerPlaying = playerStore((state) => state.isPlaying);
  const isMusicReallyPaused = musicPlayerStore((state) => state.isMusicReallyPaused);

  const coverPicRef = useRef();

  const videoJsOptions = {
    autoplay: false,
    controls: false,
    poster: "./poster.png",
    controlBar: {
      pictureInPictureToggle: false,
      currentTimeDisplay: true
    },
    experimentalSvgIcons: true,
    responsive: false,
    fluid: false,
    width: "100%",
    height: "100%",

  };

  const [imageRect, setImageRect] = useState();

  useEffect(() => {
    fixScaling(imageRect);
  }, [streamUrl]);

  useEffect(() => {
    const imageElements = document.getElementsByClassName("muvika-cover-image");

    if (imageElements.length !== 0) {
      const image = imageElements[0];
      const imageRect = image.getBoundingClientRect();
      if (imageRect.height != 0) {
        console.log("cover player", imageRect);
        setImageRect(imageRect);
      }
    }

  }, [coverPicRef]);

  const play = () => {
    getStreamUrl(sessionToken, props.track);
  };

  const stop = () => {
    setIsPlaying(false);
  };

  const renderMuteIcon = () => {
    if (isPlayerPlaying.isPlaying || !isMusicReallyPaused.isPaused) {
      return <MusicOffIcon className="muvika-cover-player-mute-icon" />;
    }
  };

  const forward5 = () => {
    setFrom(currentTime + 5);
  }

  const renderPlayStopButton = () => {
    if (account) {
      if (!(account.subscription.valid == 0)) {
        if (previewPlayerStore.getState().isPlaying.isPlaying) {
          return <Stack className="muvika-cover-player-stack" direction="row" spacing={0.3}>
            <Button onClick={() => stop()} className="muvika-cover-player-stack-button" size="small"><StopIcon />{TR.cm_stop} {renderMuteIcon()}</Button>
            <Button onClick={() => forward5()} className="muvika-cover-player-stack-icon"><SvgIcon className="muvika-cover-player-icon" component={Forward5Icon} /></Button>
          </Stack>;
        } else {
          return <Button onClick={() => play()} className="muvika-cover-player-button" size="small"><PlayArrowIcon />{TR.cm_preview}</Button>;
        }
      }
    }
  };

  const renderCoverPic = () => {
    return <img ref={coverPicRef} className="muvika-cover-image" style={{ display: previewPlayerStore.getState().isPlaying.isPlaying ? "none" : "block" }} src={props.track.url_cover_image} alt="" />;
  };

  const fixScaling = (imageRect) => {
    if (!imageRect) {
      return;
    }

    const playerElements =
      document.getElementsByClassName("muvika-cover-player");

    if (playerElements.length === 0) {
      return;
    }

    const videos = playerElements[0].getElementsByTagName("video");

    if (videos.length === 0) {
      return;
    }

    const video = videos[0];

    const targetHeight = imageRect.height;

    video.style.setProperty("height", targetHeight + "px", "important");
  };


  const renderPlayer = () => {
    return <DialogPreviewPlayer
      className="muvika-player-video"
      style={{ height: "100%", display: previewPlayerStore.getState().isPlaying.isPlaying ? "block" : "none" }}
      options={videoJsOptions}
    />;
  };

  return (
    <div className="muvika-cover-player">
      {renderPlayStopButton()}
      {renderCoverPic()}
      {renderPlayer()}
    </div>
  );
};

export default DialogPlayer;